import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from 'app/core/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PolicyTemplateService {
    private _apiService = inject(ApiService);

    constructor(private _httpClient: HttpClient) {}

    // Cancellation Policy Templates
    getCancellationTemplates(): Observable<any> {
        return this._apiService.get('policy-templates/cancellation-templates');
    }

    getCancellationTemplatesPage(page: number, limit: number): Observable<any> {
        return this._apiService.get(
            `policy-templates/cancellation-templates?paginated=true&page=${page}&limit=${limit}`
        );
    }

    getCancellationTemplateById(id: string): Observable<any> {
        return this._apiService.get(`policy-templates/cancellation-templates/${id}`);
    }

    createCancellationTemplate(template: any): Observable<any> {
        return this._apiService.post('policy-templates/cancellation-templates', template);
    }

    updateCancellationTemplate(id: string, template: any): Observable<any> {
        return this._apiService.put(`policy-templates/cancellation-templates/${id}`, template);
    }

    deleteCancellationTemplate(id: string): Observable<any> {
        return this._apiService.delete(`policy-templates/cancellation-templates/${id}`);
    }

    // Privacy Policy Templates
    getPrivacyTemplates(): Observable<any> {
        return this._apiService.get('policy-templates/privacy-templates');
    }

    getPrivacyTemplatesPage(page: number, limit: number): Observable<any> {
        return this._apiService.get(
            `policy-templates/privacy-templates?paginated=true&page=${page}&limit=${limit}`
        );
    }

    getPrivacyTemplateById(id: string): Observable<any> {
        return this._apiService.get(`policy-templates/privacy-templates/${id}`);
    }

    createPrivacyTemplate(template: any): Observable<any> {
        return this._apiService.post('policy-templates/privacy-templates', template);
    }

    updatePrivacyTemplate(id: string, template: any): Observable<any> {
        return this._apiService.put(`policy-templates/privacy-templates/${id}`, template);
    }

    deletePrivacyTemplate(id: string): Observable<any> {
        return this._apiService.delete(`policy-templates/privacy-templates/${id}`);
    }
}

